import SelectableTile from '@carvana/ds-selectable-tile';
import tileStyles from '@/new-cars/common/SelectableTile.module.css';
import VehicleMakeIcon from '~/components/common/VehicleMakeIcon';
import {
  Content,
  ImageArea,
  ImagePlaceholder,
  OptionName,
  PriceAdd
} from './PackageOptionCard.styles';

type OwnProps = {
  make: string;
};

export default function NoPackageOptionAvailableCard({ make }: OwnProps) {
  return (
    <SelectableTile
      className={tileStyles.tile}
      selected
      tabIndex={-1}
      data-analytics-id="New Cars"
      data-analytics-attributes={JSON.stringify({
        level: 'Options',
        section: 'Packages',
        text: 'No options or packages',
        tileAction: 'selected'
      })}
      data-testid="package-option-card-no-options"
      value="no-options"
    >
      <ImageArea>
        <ImagePlaceholder>
          <VehicleMakeIcon aria-hidden="true" make={make} size={80} />
        </ImagePlaceholder>
      </ImageArea>
      <Content>
        <OptionName>No options or packages</OptionName>
        <PriceAdd>+$0</PriceAdd>
      </Content>
    </SelectableTile>
  );
}
